import { AlphaSIcon } from './AlphaSIcon';

/**
 * author: GreenTurtwig
 * id 5E4ECB99-9DA0-419C-AADE-F2F7AE91FF6A
 * name alpha-s
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-s.svg
 * tags
 * - Alpha / Numeric 
 */
export const LetterSIcon = AlphaSIcon;
export default LetterSIcon